import * as AceCollabExt from '@convergencelabs/ace-collab-ext';
// import * as ace from 'ace-builds';
import { record as rrwebRecorder } from 'rrweb';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

/* Generating a random color for the user. */
const randomColor = `#${Math.floor(Math.random() * 16777215).toString(16)}`;

//an helper function for joining and creating room
export const socketRoom = (
  name,
  room,
  userId,
  create,
  socket,
  setLoading,
  flag,
  setFlag,
  aceEditor,
  userData,
  setLocalUser,
  updateCurMagStore,
  updateUserCurStore,
  cur,
  setRadarViewMgr,
  cursorFeat,
  radarFeat,
  api
) => {
  if (create) {
    const state = { id: room };
    //perform create function specified in socket.io for args user and error
    return socket.emit(
      'create',
      { name, room, userId, color: randomColor, state },
      ({ error, user }) => {
        //send name and room
        setLoading(false);
        if (error) {
          setFlag({ ...flag, error: true, msg: error });
        }
        // create cursor manager from ACEditor
        const curMgr = new AceCollabExt.AceMultiCursorManager(
          aceEditor.current.editor.getSession()
        );

        /* Creating a radar view for the editor. */
        const radarView = new AceCollabExt.AceRadarView(
          'radar-view',
          aceEditor.current.editor
        );

        /* Setting the radarViewMgr to the radarView. */
        setRadarViewMgr(radarView);

        /* Getting the visible index range of the editor. */
        const initialIndices =
          AceCollabExt.AceViewportUtil.getVisibleIndexRange(
            aceEditor.current.editor
          );
        /* Getting the visible index range of the editor and then converting it to rows. */
        const initialRows = AceCollabExt.AceViewportUtil.indicesToRows(
          aceEditor.current.editor,
          initialIndices.start,
          initialIndices.end
        );
        /* Adding a view to the radarView. */
        radarView.addView(user.userId, user.name, user.color, initialRows, 0);

        const userD = {
          userId: user.userId,
          name: user.name,
          room: user.room,
          color: user.color,
        };
        setLocalUser(userD);
        // cursor controller
        updateCurMagStore(curMgr);

        // add cursor for the new user
        curMgr.addCursor(user.userId, user.name, user.color, 0);

        // console.log(localUser)
        // Create a subject to hold the last record
        const lastRecordSubject = new Subject();

        // Subscribe to the subject to get the last record
        lastRecordSubject
          .pipe(debounceTime(1000)) // Debounce the stream to handle rapid record changes
          .subscribe((lastRecords) => {
            let time = 0;
            time = time + 1;
            console.log(`sending ${time}`);
            api
              .put(`/data?id=${lastRecords.id}`, {
                data: lastRecords.events,
              })
              .then((res) => {
                console.log(res);
              });
          });

        // start the recorder feature
        api
          .post('/record', {
            name: user.room,
            description: 'This is a recording of ' + room,
            time: new Date(),
            user: user.name,
          })
          .then((res) => {
            if (res.data.status) {
              let id;
              const events = [];
              rrwebRecorder({
                emit(event) {
                  // send events to server
                  console.log(event);
                  events.push(event);
                  if (events.length === 1) {
                    api
                      .post('/data', {
                        name: user.name,
                        data: events,
                        recordId: user.room,
                        user: user.name,
                        dataId: Math.random().toString(36).substr(2, 9),
                      })
                      .then((res) => {
                        console.log(res.data);
                        id = res.data.record.id;
                      });
                  } else {
                    if (id !== undefined) {
                      lastRecordSubject.next({ id, events });
                    }
                  }
                },
              });
            }
          });
      }
    );
  } else {
    return socket.emit(
      'join',
      { name, room, userId, color: randomColor },
      ({ error, user }) => {
        console.log('socket join', user);
        setLoading(false);
        if (error) {
          console.log('socket', error);
          setFlag({ ...flag, error: true, msg: error });
        }
        // create cursor manager from ACEditor
        try {
          const curMgr = new AceCollabExt.AceMultiCursorManager(
            aceEditor.current.editor.getSession()
          );

          /* Creating a radar view for the editor. */
          const radarView = new AceCollabExt.AceRadarView(
            'radar-view',
            aceEditor.current.editor
          );

          /* Setting the radarViewMgr to the radarView. */
          setRadarViewMgr(radarView);

          /* Getting the visible index range of the editor. */
          const initialIndices =
            AceCollabExt.AceViewportUtil.getVisibleIndexRange(
              aceEditor.current.editor
            );
          /* Getting the visible index range of the editor and then converting it to rows. */
          const initialRows = AceCollabExt.AceViewportUtil.indicesToRows(
            aceEditor.current.editor,
            initialIndices.start,
            initialIndices.end
          );
          /* Adding a view to the radarView. */
          radarView.addView(user.userId, user.name, user.color, initialRows, 0);

          // cursor controller
          updateCurMagStore(curMgr);

          // Create a subject to hold the last record
          const lastRecordSubject = new Subject();

          // Subscribe to the subject to get the last record
          lastRecordSubject
            .pipe(debounceTime(1000)) // Debounce the stream to handle rapid record changes
            .subscribe((lastRecords) => {
              let time = 0;
              time = time + 1;
              console.log(`sending ${time}`);
              api
                .put(`/data?id=${lastRecords.id}`, {
                  data: lastRecords.events,
                })
                .then((res) => {
                  console.log(res);
                });
            });

          // start the recorder feature
          let id;
          const events = [];
          rrwebRecorder({
            emit(event) {
              // send events to server
              console.log(event);
              events.push(event);
              if (events.length === 1) {
                api
                  .post('/data', {
                    name: user.name,
                    data: events,
                    recordId: user.room,
                    user: user.name,
                    dataId: Math.random().toString(36).substr(2, 9),
                  })
                  .then((res) => {
                    console.log(res.data);
                    id = res.data.record.id;
                  });
              } else {
                if (id !== undefined) {
                  lastRecordSubject.next({ id, events });
                }
              }
            },
          });

          // add cursor for the new user
          curMgr.addCursor(user.userId, user.name, user.color, 0);

          const userD = {
            userId: user.userId,
            name: user.name,
            room: user.room,
            color: user.color,
          };
          setLocalUser(userD);
        } catch (error) {
          console.log(error);
        }
        // console.log(localUser)
      }
    );
  }
};
